import { apiSlice } from "../apiSlice";

export const adminxxxApiSlice = apiSlice.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getUsersChangeByName: builder.query({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx/getUsers`,
        method: "GET",
        params: { ...parameters },
        headers: { modulecima: "parmpoxx" },
      }),
      providesTags: ["Create"],
    }),
    createHistory: builder.mutation({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx`,
        method: "POST",
        body: {
          ...parameters,
        },
        headers: { modulecima: "parmpoxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    returnUser: builder.mutation({
      query: (parameters) => ({
        url: `/Parmpoxx/Adminxxx/` + parameters.SECINGID,
        method: "PUT",
        body: {
          ...parameters.body,
        },
        headers: { modulecima: "parmpoxx" },
      }),
      invalidatesTags: ["Create"],
    }),
    deleteHistory: builder.mutation({
      query: (SECINGID) => ({
        url: `/Parmpoxx/Adminxxx/` + SECINGID,
        method: "DELETE",
      }),
      invalidatesTags: ["Create"],
    }),
  }),
});

export const {
  useLazyGetUsersChangeByNameQuery,
  useCreateHistoryMutation,
  useReturnUserMutation,
  useDeleteHistoryMutation,
} = adminxxxApiSlice;
